import { useTranslation } from "react-i18next";
import type { ReleaseRequest } from "./releaseRequest";
import { processTerm } from "../../../api/content/processTerms";
import { classText } from "../../workflows/inputCards/typeWords";
import ContentVersionName from "../../versions/labels/ContentVersionName";

/** A release request as the steps after it read it: what, the metadata and where, so far. */
export default function ReleaseRequestSummary({ projectId, request }: { projectId: string; request: ReleaseRequest }) {
  const { t } = useTranslation();
  const { metadata, publish_to_researchspace: publish } = request;
  return (
    <dl className="app-surface-muted grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 rounded p-2 text-sm">
      <dt className="app-text-muted">{classText(processTerm("ContentVersion"), t)}</dt>
      <dd><ContentVersionName projectId={projectId} reference={request.model_version} /></dd>
      <dt className="app-text-muted">{t("data.release.results")}</dt>
      <dd>{t("data.release.step.members", { count: request.members.length })}</dd>
      {metadata === null ? null : (
        <>
          <dt className="app-text-muted">{t("data.dataset.fields.title")}</dt>
          <dd>{metadata.title}</dd>
          <dt className="app-text-muted">{t("data.dataset.fields.licence")}</dt>
          <dd>{metadata.licence}</dd>
        </>
      )}
      {publish === null ? null : (
        <>
          <dt className="app-text-muted">{t("data.researchSpace.label")}</dt>
          <dd>{publish ? t("data.release.step.toResearchSpace") : t("data.release.step.staysInDmw")}</dd>
        </>
      )}
    </dl>
  );
}
